import Button, { ButtonProps } from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

interface Props extends ButtonProps {
    loading: boolean;
};

const LoadingButton = ({ loading, ...props }: Props) => {
    return (
        <Button
            fullWidth
            size="large"
            variant="contained"
            disabled={loading}
            {...props}
        >
            {loading ? <CircularProgress sx={{ mx: 4, my: 0.3, color: "white" }} size={25} /> : props.children}
        </Button>
    );
};
export default LoadingButton;